import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=64a905c0&scoped=true"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=64a905c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a905c0",
  null
  
)

export default component.exports